var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('detail',{attrs:{"on-manager":_vm.onManager,"data":_vm.itemData,"base-info":_vm.baseInfo,"extra-info":_vm.extraInfo,"resource":"hosts","status-module":"host"}})}
var staticRenderFns = []

export { render, staticRenderFns }